// src/components/layout/PageHeader.jsx
//
// Below the top bar: white background, ~70px tall.
// Eyebrow (gold-deep, uppercase) + serif H1 (32-36px, weight 500) +
// optional right slot (CTA, count summary, etc.).
import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { fonts } from "../../theme/tokens";
import Eyebrow from "../brand/Eyebrow";

export default function PageHeader({ eyebrow, title, rightSlot, sx }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        px: 4,
        pt: 3,
        pb: 2.25,
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.brand.border}`,
        flexShrink: 0,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: 2,
        ...sx,
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        {eyebrow && (
          <Eyebrow sx={{ mb: 0.75, color: theme.palette.brand.goldDeep }}>{eyebrow}</Eyebrow>
        )}
        {title && (
          <Typography
            component="h1"
            sx={{
              fontFamily: fonts.serif,
              fontSize: 32,
              fontWeight: 500,
              lineHeight: 1.1,
              letterSpacing: "-0.02em",
              m: 0,
              color: theme.palette.brand.ink,
            }}
          >
            {title}
          </Typography>
        )}
      </Box>
      {rightSlot && <Box sx={{ flexShrink: 0 }}>{rightSlot}</Box>}
    </Box>
  );
}
